import { adminHttpClient } from '../../../commons/adminHttpClient'
import { PaymentStatus } from 'domain/benefit/paymentStatus'

export interface Subscription {
  subscriptionPlan: FrequencyType
  renewsOn: string
  baseFee: number
  perEEFee: number
  paymentMethod: PaymentMethod
  paymentDetails: CreditCardDetails | ACHDetails
  billingEmail: string
  years: number[]
}

export type ACHDetails = {
  accountType: string
  bankRoutingNumber: string
  accountNumber: string
  nameOnAccount: string
}

export type CreditCardDetails = {
  firstName: string
  lastName: string
  cardNumberLastFour: string
  expirationMonth: string
  expirationYear: string
}

interface Invoice {
  date: string
  invoiceNumber: number
  amount: number
  status: PaymentStatus
}

export enum PaymentMethod {
  CreditCard = 0,
  ACH = 1,
}

enum FrequencyType {
  Monthly = 0,
  Yearly = 1,
}

export const getSubscriptionDetails = (): Promise<Subscription> => {
  return adminHttpClient.get('/AdminDashboard/CompanySettings/CompanySubscription')
}

export default getSubscriptionDetails
